import { useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Channel } from "../../Channel";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import { CreateOfferData } from "../../../types/offers";

export function Type() {
  const formik = useFormikContext<CreateOfferData>();
  return (
    <Stack spacing={4}>
      <Typography color="primary">Tipos de oferta</Typography>
      <RadioGroup
        value={formik.values.type}
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        onChange={(_, value) => formik.setFieldValue("type", value)}
      >
        <Grid container spacing={2}>
          <Grid display="flex" item xs={4}>
            <Channel
              value="personalized"
              title="Personalizada"
              subtitle="Escolha uma audiência para oferecer a oferta."
            />
          </Grid>
          <Grid display="flex" item xs={4}>
            <Channel
              value="price_two"
              title="Preço dois"
              subtitle="Escolha uma loja para oferecer o descontos para todos os clientes."
            />
          </Grid>
          <Grid display="flex" item xs={4}>
            <Channel
              value="one_to_one"
              title="One to one"
              subtitle="Escolha uma pessoa para oferecer uma oferta exclusiva."
            />
          </Grid>
        </Grid>
      </RadioGroup>
    </Stack>
  );
}
